import React from 'react';
import { Box, DialogActions, DialogContent, Typography } from '@mui/material';
import Button from '@mui/material/Button';
import { useCommonSlice } from '../../../../store/commonSlice';
import { useDispatch } from 'react-redux';
import { FormProvider, SubmitHandler, useForm } from 'react-hook-form';
import TextInput from '../../../components/Form/TextInput';
import SelectInput from '../../../components/Form/SelectInput';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { survey_question } from '../interface';

interface FormQuestionsProps {
  handleSubmit: (data: any) => void;
  questions: Array<any>;
}

export const QUESTION_FORMAT_OPTIONS = [
  { name: 'プルダウン', value: 'プルダウン', key: 'pull-down' },
  {
    name: 'チェックボックス',
    value: 'チェックボックス',
    key: 'singular-selection',
  },
  {
    name: 'テキストフィールド',
    value: 'テキストフィールド',
    key: 'text-field',
  },
];

const validateForm = yup.object().shape({
  question_content: yup.string().required('質問内容が必須です'),
  question_flag: yup
    .number()
    .typeError('必須フラグが無効です')
    .required('必須フラグが必須です'),
  question_format: yup
    .string()
    .max(32, '回答形式が無効です')
    .required('回答形式が必須です'),
  question_hidden_flag: yup
    .number()
    .typeError('非表示フラグが必須です')
    .required('非表示フラグが必須です'),
});

const AddFormQuestion = (props: FormQuestionsProps) => {
  const { actions } = useCommonSlice();
  const dispatch = useDispatch();
  const methods = useForm<any>({ resolver: yupResolver(validateForm) });

  const onSubmit: SubmitHandler<any> = (data: survey_question) => {
    const nData = { ...data };
    nData.question_no = newId;
    props.handleSubmit(nData);
    dispatch(actions.closeModal());
  };

  const questions = props.questions;
  const lastQuestions =
    questions?.length > 0 ? questions[questions.length - 1] : null;
  const newId = lastQuestions?.question_no ? lastQuestions.question_no + 1 : 1;

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit)}>
        <DialogContent dividers className="dialogContentModal">
          {/* <TextInput name={'question_no'} labelName={'表示番号'} showLabel /> */}
          <Box sx={{ flexDirection: 'row', display: 'flex' }}>
            <Typography sx={{ marginRight: 1 }}>{'表示番号   '}</Typography>
            <Typography sx={{ fontWeight: 'bold' }}>{newId}</Typography>
          </Box>
          <TextInput
            name={'question_content'}
            labelName={'質問内容'}
            showLabel
          />
          <SelectInput
            name={'question_format'}
            labelName={'回答形式'}
            showLabel
            options={QUESTION_FORMAT_OPTIONS}
          />
          <TextInput
            name={'question_choices'}
            labelName={'回答選択肢(カンマ区切り)'}
            showLabel
          />
          <SelectInput
            name={'question_flag'}
            labelName={'必須フラグ'}
            showLabel
            options={[
              { name: 'オン', value: 1 },
              { name: 'オフ', value: 0 },
            ]}
          />
          <SelectInput
            name={'question_hidden_flag'}
            labelName={'非表示フラグ'}
            showLabel
            options={[
              { name: 'オン', value: 1 },
              { name: 'オフ', value: 0 },
            ]}
          />
          <Typography
            variant={'body1'}
            fontWeight={'bold'}
            color={'#0000FF'}
            mt={3}
          >
            {'回答形式に関して'}
          </Typography>
          <Typography
            variant={'body1'}
            fontWeight={'bold'}
            color={'#0000FF'}
            mb={4}
          >
            {'プルダウン/チェックボックス/テキストフィールド'}
          </Typography>
          <Typography variant={'body1'} fontWeight={'bold'} color={'#0000FF'}>
            {'必須フラグ'}
          </Typography>
          <Typography
            variant={'body1'}
            fontWeight={'bold'}
            color={'#0000FF'}
            mb={2}
          >
            {'有効/無効'}
          </Typography>
        </DialogContent>
        <DialogActions className="dialogActionModal">
          <Button
            autoFocus
            variant={'text'}
            onClick={() => dispatch(actions.closeModal())}
            className="btnModalCancel"
          >
            Cancel
          </Button>
          <Button variant={'text'} type={'submit'} className="btnModalSubmit">
            ADD
          </Button>
        </DialogActions>
      </form>
    </FormProvider>
  );
};

export default AddFormQuestion;
